<template>
  <section id="user-overview">
    <v-layout row wrap align-content-center justify-center>
      <v-flex xs12>
        <section class="section-header" row wrap align-content-center justify-center>
          <h1 class="section-title">
            <v-icon color="deep-orange darken-2">fal fa-smile</v-icon>
            Olá, {{ user.first_name }}!
          </h1>
        </section>
      </v-flex>
      <v-flex xs12 md6>
        <div class="section-box text-xs-center section-widget">
          <v-alert :value="!evaluations || !evaluations.length" color="grey lighthen-1" outline>
            Nenhum dado de Peso
          </v-alert>
          <chart-line v-if="evaluations && evaluations.length" :height="200" :chartData="{
            labels: chartsLabelsDate,
            datasets: [
              { label: 'Peso', data: chartWeightData, backgroundColor: chartColor },
            ]
          }"></chart-line>
        </div>
      </v-flex>
      <v-flex xs12 md6>
        <div class="section-box text-xs-center section-widget">
          <v-alert :value="!evaluations || !evaluations.length" color="grey lighthen-1" outline>
            Nenhum dado de Gordura Corporal
          </v-alert>
          <chart-line v-if="evaluations && evaluations.length" :height="200" :chartData="{
            labels: chartsLabelsDate,
            datasets: [
              { label: 'Gordura Corporal', data: chartBodyFatData, backgroundColor: chartColor }
            ]
          }"></chart-line>
        </div>
      </v-flex>

      <v-flex xs12>
        <health-card-notify v-if="!healthCard"></health-card-notify>
      </v-flex>

      <v-flex xs12 v-if="healthCard && healthCard.physical_objectives">
        <v-alert :value="true" color="grey darken-1" icon="fal fa-bullseye-arrow" outline>
          <strong>Seu objetivo:</strong>
          {{ healthCard.physical_objectives }}
        </v-alert>
      </v-flex>
    </v-layout>
  </section>
</template>

<script>
import router from '@/router'
import axios from 'axios'
import EventBus from '@/event-bus'

import UserHealthCardNotify from '@/components/user/evaluations/UserHealthCardNotify'
import ChartLine from '@/components/user/overview/ChartLine'

export default {
  data: () => ({
    user: JSON.parse(localStorage.getItem('currentUser')),
    chartColor: '#fab1a0',
    healthCard: null,
    evaluations: null,
    chartWeightData: [],
    chartBodyFatData: [],
    chartsLabelsDate: []
  }),

  methods: {
    buildChartLabelsDate (date) {
      const dateFormatted = this.$moment(date).format('DD/MM/YYYY')
      this.chartsLabelsDate.push(dateFormatted)
    },

    buildChartWeight (weight) {
      this.chartWeightData.push(weight)
    },

    buildChartBodyFat (bodyFat) {
      this.chartBodyFatData.push(bodyFat)
    },

    buildCharts (evaluations) {
      for (let evaluation of evaluations.reverse()) {
        if (evaluation.body_weight) this.buildChartWeight(evaluation.body_weight)
        if (evaluation.body_fat) this.buildChartBodyFat(evaluation.body_fat)
        if (evaluation.created_at) this.buildChartLabelsDate(evaluation.created_at)
      }
    },

    loadHealthCard () {
      EventBus.$emit('appLoading', true)
      // eslint-disable-next-line
      let path = `${API.userHealthyCards}/users/${this.user._id}`

      axios.get(path).then(response => {
        if (response.data.healthy_card) { this.healthCard = response.data.healthy_card }
        EventBus.$emit('appLoading', false)
        this.loadEvaluations()
      }).catch(errors => {
        EventBus.$emit('appLoading', false)
      })
    },

    loadEvaluations () {
      EventBus.$emit('appLoading', true)
      // eslint-disable-next-line
      let path = `${API.userEvaluations}/users/${this.user._id} `

      axios.get(path).then(response => {
        if (response.data.evaluations) {
          this.evaluations = response.data.evaluations
          this.buildCharts(this.evaluations)
        }
        EventBus.$emit('appLoading', false)
      }).catch(errors => {
        EventBus.$emit('appLoading', false)
      })
    },

    redirect () {
      router.push({
        name: 'UserTrainings'
      })
    }
  },

  mounted () {
    // this.redirect()
    this.loadHealthCard()
  },

  components: {
    'health-card-notify': UserHealthCardNotify,
    ChartLine
  }
}
</script>

<style src="../../assets/scss/components/overview.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/components/user/UserOverview.vue